import { requestHelpers } from "../../helpers";

export const actions = {
    SET_BT_EXPERTISE: "SET_BT_EXPERTISE",
    CREATE_BT_EXPERTISE: "CREATE_BT_EXPERTISE",
    GET_BT_EXPERTISE: "GET_BT_EXPERTISE",
};

export const getBTExpertise = ( personId ) => {
    return (dispatch) => {
        dispatch( {
            type: actions.GET_BT_EXPERTISE,
            isFetching: true,
            isError: false,
        } );

            requestHelpers
                .authenticatedGetRequest( `/profiles/${ personId }/business-transformation` )
                .then( (response) => {
                    if ( response.success ) {
                        return dispatch( {
                            type: actions.SET_BT_EXPERTISE,
                            btExpertise: response.data,
                            isFetching: false,
                            isError: false,
                        } );
                    }
                } )
                .catch( ex => console.log( "Error: ", ex ) );
    }
};

export const createBTExpertise = ( personId, payload, normalisedData ) => {
    return dispatch => {
        requestHelpers
            .authenticatedPostRequest( `/profiles/${ personId }/business-transformation`, { ...payload } )
            .then( response => {
                return dispatch( {
                    type: actions.CREATE_BT_EXPERTISE,
                    normalisedData,
                } );
            } )
            .catch( ex => console.log( "Error: ", ex ) );
    };
}


// WEBPACK FOOTER //
// src/client/actions/profile/BTexpertise.js